import { S, SA, DC, RCL, ACL, RCLA, TEXT } from '../../Utilities';

export default () => {
    SA('.read_more').forEach( block => {

        if (block.innerHTML.length > 300) {
            const allText = DC('div', 'read_more_all');
            const summaryText = DC('div', 'read_more_summary');
            const btnLabel = TEXT('Meer lezen');


            summaryText.innerHTML = block.innerHTML;
            const txt = (summaryText.textContent || summaryText.innerText || '');
            const words = txt.replace(/\s+/g, ' ').split(' ');
            words.length = 40;


            summaryText.innerHTML = `<p>${words.join(' ')} ... <a href="#" class="read_more_summary">verder lezen</a></p>`;

            allText.innerHTML = block.innerHTML;

            block.innerHTML = '';

            block.appendChild(summaryText);

            block.appendChild(allText);

            const readMoreBtn = S('.read_more_summary', block);

            readMoreBtn.addEventListener('click', e => {
                block.removeChild(summaryText);
                ACL(allText, 'show');
                e.preventDefault();
            });
        }   
    });
}